/**
 * Collection + product: activate italic @font-face after LCP.
 * UI weights (500/600) stay critical — H1/buttons need them above the fold.
 */
(function () {
  var style = document.getElementById('collection-late-font-faces');

  var done = false;
  function activate() {
    if (done) return;
    done = true;
    if (style) {
      style.media = 'all';
      style.removeAttribute('data-collection-late-fonts');
    }
    document.querySelectorAll('link[data-gropulse-late]').forEach(function (link) {
      link.media = 'all';
    });
  }

  if (!style && !document.querySelector('link[data-gropulse-late], script#gropulse-css-defer')) return;

  function afterLcpOrTimeout() {
    if (typeof PerformanceObserver === 'undefined') {
      setTimeout(activate, 4000);
      return;
    }

    var finished = false;
    try {
      var po = new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        if (!entries.length) return;
        finished = true;
        try {
          po.disconnect();
        } catch (e) {
          /* ignore */
        }
        if (window.requestIdleCallback) {
          requestIdleCallback(activate, { timeout: 2000 });
        } else {
          setTimeout(activate, 200);
        }
      });
      po.observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (e) {
      setTimeout(activate, 4000);
      return;
    }

    setTimeout(function () {
      if (!finished) activate();
    }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', afterLcpOrTimeout);
  } else {
    afterLcpOrTimeout();
  }
})();
